export default __webpack_public_path__ + "static/media/previousMeeting.7d1035f9.gif";